const API_URL = process.env.VUE_APP_API_URL

export const AUTH_URL = `${API_URL}auth`
export const RATE_URL = `${API_URL}rates`
export const PROJECT_URL = `${API_URL}projects`
export const DEAL_URL = `${API_URL}deals`
export const EMAIL_URL = `${API_URL}emails`
export const PROJECT_QUOTE_URL = `${API_URL}project-quotes`
export const PROJECT_QUOTE_ITEM_URL = `${API_URL}project-quote-items`
export const USER_URL = `${API_URL}users`
export const STAFF_QUOTE_URL = `${API_URL}staff-quotes`
export const SPRINT_URL = `${API_URL}sprints`
export const COMMON_URL = `${API_URL}common`
export const HOME_URL = `${API_URL}home`
export const PROJECT_WORK_ORDER_URL = `${API_URL}project-work-orders`
export const STAFF_WORK_ORDER_URL = `${API_URL}staff-work-orders`
export const SUPPORT_WORK_ORDER_URL = `${API_URL}support-work-orders`
export const INVOICE_STAFF_WORK_ORDER_URL = `${API_URL}invoice-staff-work-orders`
export const INVOICE_SUPPORT_WORK_ORDER_URL = `${API_URL}invoice-support-work-orders`
export const INVOICE_STAFF_WORK_ORDER_FILES_URL = `${API_URL}invoice-staff-work-order-files`
export const INVOICE_PROJECT_WORK_ORDER_FILES_URL = `${API_URL}invoice-project-work-order-files`
export const INVOICE_PROJECT_WORK_ORDER_URL = `${API_URL}invoice-project-work-orders`
export const PIPEDRIVE_DEALS_URL = `${API_URL}pipedrive/deals`
export const SUPPORT_QUOTE_URL = `${API_URL}support-quotes`
